import BlackTicketIcon from "../../assets/black/ticket.png";
import HelpIcon from "../../assets/help.png";
import menuBtn from "../../assets/menu.png";
import { BsExclamationCircle } from 'react-icons/bs'
import Tint from '../../utility/ImageTint/Tint';
import { useNavigate } from 'react-router';
const Dashboardheader = ({setManualToggleValue,istutorialinfo,colors,isNavtrue,setIsManuallyToggled,showWidth,showSidebar,hideSidebar,activeLink,navIcon,countnav,setYoutubevideo,setIsOpenHelpModal}) => {

   const navigate=useNavigate()
 
   if (!colors) return null;
   console.log(colors,"colrs")
    return (
   <div
                    className="Dashboard_header"
                    style={{ background: colors?.bgcolor }}
                >
                    <div className="left_bar">
                      <img
  src={menuBtn}
  onClick={() => {
    setIsManuallyToggled(true);
    if (showWidth === "100px") {
      showSidebar();
      setManualToggleValue(true)
    } else {
      hideSidebar();
      setManualToggleValue(false)
    }
  }}
/>

                    </div>

                    <div className="logo">
                        <img
                            src={`https://trackhr.hexbis.com/Assets/trackhricon.png`}
                            alt="TrackHr logo"
                            style={{ width: "42px" }}
                        />
                        <span
                            style={{ color: "blue", fontSize: "25px", fontWeight: "400" }}
                            className="logoNamefirstpart"
                        >
                            Track
                            <span
                                className="logoNamelastpart"
                                style={{ fontWeight: "bold" }}
                            >
                                Hr
                            </span>
                        </span>
                    </div>

                    <div className="ActiveIconBox">
                      <img
  key={navIcon}
  onClick={() => {
    if (isNavtrue) navigate(-1);
  }}
  src={navIcon}
  style={{
    filter: Tint(colors?.Primary),
    cursor: isNavtrue ? "pointer" : "default",
    animation: "rotateFade 0.3s ease"
  }}
/>



                        {
                            (activeLink != "" && navIcon != "") && <span>{activeLink}</span>}
                        {
                            istutorialinfo ? <span className=' text-danger cur-point'><BsExclamationCircle style={{ fontSize: "24px", marginBottom: "4px", cursor: "pointer" }} onClick={() => setYoutubevideo(true)} /></span> : ""
                        }
                    </div>

                    <div className="OtherBox">

                        <div style={{ position: "relative" }}>
                            <div
                                className="ticket"
                                style={{ background: colors?.Ticket }}
                                onClick={() => {
                                     navigate("/tickets")
                                }}
                            >
                                <img src={BlackTicketIcon} style={{ filter: "invert(1)" }} />
                            </div>
                            {countnav.length > 0 && (
                                <>
                                    {countnav[0].pendingtickets < 100 ? (
                                        <div className="textcount">
                                            <p style={{marginBottom:"0px"}}>{countnav[0].pendingtickets}</p>
                                        </div>
                                    ) : (
                                        <div className="textcount2">
                                            <p style={{marginBottom:"0px"}}>99+</p>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                        <div
                            className="Help"
                            onClick={() => setIsOpenHelpModal(true)}
                        >
                            <img src={HelpIcon} />
                        </div>
                    </div>
                </div>
  )
}
export default Dashboardheader